import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { SignedBalanceAmount } from "web_myplann/Finances/Components/SignedBalanceAmount";

type Props = {
	title: string;
	balance: number;
	size: "lg" | "md";
};

export const BalanceHero: FC<Props> = ({ title, balance, size }) => {
	const theme = useTheme();

	const isLarge = size === "lg";

	return (
		<Stack
			alignItems="center"
			textAlign="center"
			bgcolor={theme.palette.background.paper}
			px={theme.spacingTokens.lg}
			pt={isLarge ? theme.spacingTokens.section : theme.spacingTokens.lg}
			pb={isLarge ? theme.spacingTokens.lg : theme.spacingTokens.sm}
			gap={isLarge ? theme.spacingTokens.sm : theme.spacingTokens.xs}
		>
			<Typography variant="body2">{title}</Typography>
			<SignedBalanceAmount balance={balance} size={size} />
		</Stack>
	);
};
